import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CandidateModel } from '../../../models/candidate.model';
import { GroupModel } from '../../../models/group.model';
import { SlotModel } from '../../../models/slot.model';
import { AcStatusTimingsType, SlotStatus, TimerType } from '../../../models/acstatus/ac-status.type';
import { Subscription } from 'rxjs';
import { TimingService } from '../../../services/timing.service';
import { Moment } from 'moment';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit, OnChanges, OnDestroy {

  @Input() slot: SlotModel = null;
  @Input() candidate: CandidateModel = null;
  @Input() group: GroupModel = null;
  @Input() mode: TimerType = TimerType.Exercise;

  private hash: string;
  public status: SlotStatus | null;
  public seconds: number | null;
  public percent: number | null;

  public timingSubscription: Subscription = null;
  public clockSubscription: Subscription = null;

  public SlotStatus = SlotStatus;
  public TimerType = TimerType;

  constructor(
    private data: DataService,
    private timing: TimingService
  ) { }

  ngOnInit(): void {
    this.hash = this.data.getHash(this.slot, this.candidate, this.group);
    this.clockSubscription = this.timing.clock$.subscribe((now: Moment) => {
      if (this.slot && this.hash) {
        this.seconds = this.slot.getTime(now, this.hash, this.mode);
        const duration = (this.mode === TimerType.Rating) ? this.slot.rating_duration : this.slot.duration ;
        if (duration > 0) {
          this.percent = Math.round(100 - 100 * this.seconds / (duration * 60));
        }
      }
    });
    if (this.slot) {
      this.setSlotSubscription();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.slot?.currentValue?.id !== changes.slot?.previousValue?.id) {
      this.resetSlotSubscription();
      this.setSlotSubscription();
    }
  }

  ngOnDestroy(): void {
    this.resetSlotSubscription();
    if (this.clockSubscription !== null) {
      this.clockSubscription.unsubscribe();
    }
  }

  private setSlotSubscription(): void {
    this.timingSubscription = this.slot.timings$.subscribe((timings: { [key: string]: AcStatusTimingsType }) => {
      if (this.hash !== null && timings[this.hash] && timings[this.hash][this.mode]) {
        this.status = timings[this.hash][this.mode].status;
      } else {
        this.status = null;
      }
    });
  }

  private resetSlotSubscription(): void {
    if (this.timingSubscription !== null) {
      this.timingSubscription.unsubscribe();
    }
  }

}
